













































import Vue from 'vue'
import Message from './Message.vue'
import { UserProfile } from '@/types/users'

export default Vue.extend({
  props: {
    participants: {
      type: Array as () => UserProfile[],
      required: true
    },
    messages: {
      type: Array,
      required: true
    },
    showTypingIndicator: {
      type: String,
      required: true
    },
    colors: {
      type: Object,
      required: true
    },
    alwaysScrollToBottom: {
      type: Boolean,
      required: true
    },
    messageStyling: {
      type: Boolean,
      required: true
    },
    width: {
      type: Number,
      required: true
    },
    height: {
      type: Number,
      required: true
    }
  },
  methods: {
    _scrollDown (): void {
      const scrollList = this.$refs.scrollList as HTMLElement|undefined
      if (scrollList === undefined) return
      scrollList.scrollTop = scrollList.scrollHeight
    },
    handleScroll (e): void {
      if (e.target.scrollTop === 0) {
        this.$emit('scrollToTop')
      }
    },
    shouldScrollToBottom (): boolean {
      const scrollList = this.$refs.scrollList as HTMLElement|undefined
      if (scrollList === undefined) return false
      return this.alwaysScrollToBottom || (scrollList.scrollTop > scrollList.scrollHeight - 600)
    },
    profile (author) {
      const profile = this.participants.find((profile) => profile.id === author)

      // A profile may not be found for system messages or messages by 'me'
      return profile || { imageUrl: '', name: '' }
    }
  },
  computed: {
    defaultChatIcon () {
      return require('@/components/VueBeautifulChat/assets/chat-icon.svg')
    }
  },
  async mounted () {
    await this.$nextTick()
    this._scrollDown()
  },
  async updated () {
    if (!this.shouldScrollToBottom()) return
    await this.$nextTick()
    this._scrollDown()
  },
  components: {
    Message
  }
})
